/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './copyright-notice.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface CopyrightNoticeProps {
    /**
     * The copyright holder to display in the notice
     */
    copyrightHolder: string;

    /**
     * The year to display in the notice
     */
    year: number;
    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledCopyrightNotice = styled('p').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const CopyrightNotice: FunctionComponent<CopyrightNoticeProps> = ({
    year,
    copyrightHolder,
    ...otherProps
}: CopyrightNoticeProps) => {
    return (
        <StyledCopyrightNotice
            year={year}
            copyrightHolder={copyrightHolder}
            {...otherProps}
        >
            © {year} {copyrightHolder}
        </StyledCopyrightNotice>
    );
};
